import React from 'react'
import { Link } from '@mui/material'
import { APP_BASE_URL } from '../../constants'

import { ReactComponent as Logos } from '../../media/lacollecterie_logo_.svg'

const Logo = ({ white, ...rest }) => {
	return (
		<Link
			href={APP_BASE_URL}
			sx={(theme) => ({
				'& svg': {
					width: 229,
					[theme.breakpoints.down('md')]: {
						width: 117,
					},
				},
			})}
		>
			<Logos viewBox="0 0 219 46" {...rest} />
		</Link>
	)
}

export default Logo
